import React, { useState } from "react";
import { Flex, Typography, Button } from "antd";

import QurealSection from "../common/QurealSection";
import SectionHeader from "../components/commons/SectionHeader";
import { FileImageOutlined } from "@ant-design/icons";

import ToolsGrid, { toolsData } from "./ToolsGrid";
import BGRemover from "./Components/BgRemover";
import AIImageGenerator from "./Components/ImageGenerator";
import MergePDFs from "./pdfEditor/MergePDFs";
import RemovePassword from "./pdfEditor/RemovePassword";
import SplitPDF from "./pdfEditor/SplitPDF";
import ImageCrop from "./Components/ImageCrop";
import ImageResize from "./Components/ImageResize";
import ImageCompress from "./Components/ImageCompress";

const { Text, Title } = Typography;

const PlaceholderComponent = ({ title }) => (
    <div style={{ textAlign: "center" }}>
        <Title level={1}>{title}</Title>
        <Text>This feature is under development</Text>
    </div>
);

const toolComponents = {
    // Image Tools
    "image-resizer": ImageResize,
    "image-cropper": ImageCrop,
    "ai-image-generator": AIImageGenerator,
    "remove-background": BGRemover,
    "upscale-image": PlaceholderComponent,
    "compress-image": ImageCompress,

    // PDF Tools
    "merge-pdf": MergePDFs,
    "edit-pdf": PlaceholderComponent,
    "pdf-to-jpg": PlaceholderComponent,
    "jpg-to-pdf": PlaceholderComponent,
    "remove-pdf-password": RemovePassword,
    "split-pdf": SplitPDF,

    // AI Write Tools
    "content-improver": PlaceholderComponent,
    "paragraph-writer": PlaceholderComponent,
    "paragraph-completer": PlaceholderComponent,
};

function FileMaster() {
    const [selectedTool, setSelectedTool] = useState(null);

    const handleSelectTool = (toolKey) => {
        setSelectedTool(toolKey);
    };

    const SelectedComponent = toolComponents[selectedTool];

    return (
        <QurealSection
            header={
                <SectionHeader
                    heading="File Master"
                    icon={<FileImageOutlined />}
                />
            }
        >
            <Flex style={{ minHeight: "100vh" }}>
                {SelectedComponent ? (
                    <Flex justify="center" style={{ width: "100%" }}>
                        <SelectedComponent
                            title={
                                toolsData.find(
                                    (tool) => tool.key === selectedTool
                                )?.title
                            }
                        />
                    </Flex>
                ) : (
                    <ToolsGrid onSelectTool={handleSelectTool} />
                )}
            </Flex>
            <Button>uplaod</Button>
        </QurealSection>
    );
}

export default FileMaster;
